module.exports = __webpack_public_path__ + "img/course3.0dee0ccd.png";